import React from 'react';
import CompetitionsEditForm from '../CompetitionsEditForm';

class CompetitionsNew extends React.Component {

  componentDidMount() {
    this.props.init();
  }

  render() {
    return (
        <CompetitionsEditForm label="Create Competition" {...this.props}/>
    );
  }
}

export default CompetitionsNew;


// WEBPACK FOOTER //
// ./src/components/Competitions/CompetitionsNew/CompetitionsNew.js